module.exports = __webpack_public_path__ + "static/media/GooglePlay.6d3834a8.png";